import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { products } from '../data';
import ProductCard from '../components/ProductCard';

export default function Collection() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      exit={{ opacity: 0 }}
      className="pt-32 md:pt-40 px-6 container mx-auto min-h-screen pb-24"
    >
      <header className="mb-16 md:mb-24 md:w-3/4 lg:w-2/3">
        <motion.h1 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          className="text-fluid-h1 mb-6 md:mb-8"
        >
          CAPSULE 01
        </motion.h1>
        <motion.p 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="text-lg md:text-2xl text-graphite/70 max-w-3xl leading-relaxed"
        >
          A definitive selection of foundational garments. Stripped of excess, defined by cut, fabrication, and stark utility.
        </motion.p>
      </header>

      {isLoading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-16">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="space-y-4 animate-pulse">
              <div className="aspect-[3/4] bg-graphite/5" />
              <div className="h-4 bg-graphite/5 w-2/3" />
              <div className="h-4 bg-graphite/5 w-1/4" />
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-16">
          {products.map((product, index) => (
            <motion.div 
              key={product.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
            >
              <ProductCard product={product} />
            </motion.div>
          ))}
        </div>
      )}
    </motion.div>
  );
}